import './modules/top'
import './modules/shop'
import './modules/shop_single'
import './modules/faq'
import './modules/voice'
import './modules/assessment'
import './modules/deals_archive'
import './modules/deals_cat'
import './modules/live_shopping'
import './modules/contact'
import './modules/slider'

window.addEventListener('load', function () {
  setTimeout(function () {
    document.documentElement.classList.add('is-loaded')
  }, 500)

  if (window.matchMedia('(max-width: 999px)').matches) {
    // Nav
    var body = document.querySelector('body')
    var nav = document.getElementById('nav')
    var trigger = document.getElementById('navTrigger')
    trigger.addEventListener('click', function () {
      body.classList.toggle('scroll_stop')
      nav.classList.toggle('is-current')
      trigger.classList.toggle('is-current')
    })
  }

  const offset = 150

  document.querySelectorAll('a[href*="#"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      const hash = this.getAttribute('href')
      const target = document.querySelector(hash)

      if (target) {
        e.preventDefault()
        const top = target.getBoundingClientRect().top + window.scrollY - offset

        window.scrollTo({
          top: top,
          behavior: 'smooth',
        })
      }
    })
  })

  const faqItems = document.querySelectorAll('.faq_list > li')

  if (faqItems.length > 0) {
    faqItems.forEach((item) => {
      item.addEventListener('click', function () {
        this.classList.toggle('is-current')
      })
    })
  }

  const navItems = document.querySelectorAll('#nav li')

  navItems.forEach((item) => {
    item.addEventListener('click', function () {
      // クリックされたliに.is-currentを付与
      this.classList.toggle('is-current')
    })
  })

  const voiceList = document.querySelector('.user_voice_list')

  if (voiceList) {
    const textElements = voiceList.querySelectorAll('.js-text')

    textElements.forEach(function (textEl) {
      const readmore = textEl.nextElementSibling
      if (!readmore || !readmore.classList.contains('js-readmore')) return

      const lineHeight = parseFloat(getComputedStyle(textEl).lineHeight)
      const textHeight = textEl.offsetHeight
      const lines = Math.round(textHeight / lineHeight)

      if (lines <= 2) {
        readmore.style.display = 'none'
      }
    })

    const readmoreButtons = voiceList.querySelectorAll('.js-readmore')

    readmoreButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const textElement = btn.previousElementSibling
        const titleElement = btn.closest('dd').previousElementSibling.querySelector('.js-title')

        if (textElement && titleElement) {
          const isOpen = textElement.classList.toggle('is-open')
          titleElement.classList.toggle('is-open', isOpen)
          btn.classList.toggle('is-open', isOpen)
          btn.textContent = isOpen ? '閉じる' : '続きを読む'
        }
      })
    })
  }
})
